<template><!--隐私协议-->
  <div class="privacy">

    <div style="text-align: center; margin: 20px 0;">
      <h2>认证服务协议</h2>

      <br/>
      <span>更新时期：2026年1月1日</span>
      <br/>
      <span>生效时期：2026年1月1日</span>
    </div>

    <div>
      在您使用陌撩漂流瓶（以下简称“平台”或“我们”）提供的认证服务前，请务必仔细阅读并理解本协议，尤其关注身份证号、人脸信息等敏感个人信息的处理约定及自身权利义务。本协议具有法律效力，关联平台《隐私政策》，未明确约定的适用《隐私政策》。
      若您不同意本协议条款，或拒绝提供必要的个人信息进行认证，可能导致您无法使用平台的某些核心功能与服务（如收益提现、高级社交、特权功能等）。您有权选择停止使用相关服务。一旦您主动同意本协议或使用认证服务，即表示您已充分理解并同意受本协议及平台其他相关规则约束，自愿承担相应责任。
    </div>

    <br>

    <h3> 一、 关键定义</h3>
    <div>
      <br> 1.平台/我们：指运营方及其关联方合法拥有并运营的客户端应用、网站等相关服务载体，负责认证服务的统筹管理，履行个人信息保护主体责任。
      <br> 2.认证服务：指由平台或其合作的第三方认证机构提供的，通过人脸信息比对等方式核验用户身份，并将结果反馈至相关服务主体的服务，包括实名认证和真人认证，可根据平台服务需求单独或组合申请。
      <br> 3.认证头像：指您为真人认证目的上传的本人清晰、无遮挡照片或图像，可能包含人脸信息，按敏感个人信息标准进行严格保护。
      <br> 4.人脸信息：指为身份核验而采集的人脸图像、视频及从中提取的面部特征信息，属于《个人信息保护法》明确规定的敏感个人信息，平台将采取加密管控、严格限制访问等特殊保护措施，严禁泄露、滥用。
      <br> 5.第三方认证机构：指通过技术接口（如API/SDK）为平台提供人脸识别技术服务、具备合法资质的合作方，平台将与其签订严格保密协议及信息安全协议，对其信息处理行为进行全程监督、审计。
      <br> 6.实名认证：为遵守国家网络实名制及相关法律法规要求、保障平台服务安全（如反欺诈、未成年人保护、打击网络诈骗等），您在使用平台特定核心服务时需提供真实姓名、身份证号（敏感信息），并可能需通过人脸信息进行“人证一致性”核验，杜绝身份冒用、虚假注册等违规行为。
      <br> 7.真人认证：您主动选择此服务时，需上传认证头像。平台或其合作方将使用人脸识别技术，比对您的头像与实名信息，以验证头像真实性，杜绝虚假、盗用、AI生成头像等行为，保障平台健康社交环境，提升账号可信度。
    </div>

    <h3> 二、 信息处理与使用目的</h3>
    <div>
      <br> 平台遵循“合法、正当、必要、诚信”原则，仅收集认证服务所需的个人信息，其中敏感信息将明确告知收集及使用用途，并获得您单独同意后再进行处理，全程公开、可追溯，严格遵循相关法律法规及《隐私政策》约定。
      <br>
      <br> （一）账号实名认证
      <br> a.为审核及验证您申请实名认证的账号合法性、真实性，您同意我们收集您的真实姓名、身份证号，并通过验证身份证信息、比对您的人脸信息，确认账号使用者与认证人为同一人，防范账号冒用、盗号等安全风险。
      <br> b.您填写的实名信息将与您的平台账号唯一绑定，并依法用于平台相关服务（如收益提现、个税申报、违规行为追溯、未成年人保护及配合司法机关、监管部门核查等），不用于任何与认证及平台服务无关的场景。
      <br> c.您承诺提供的实名认证信息合法、真实、准确、完整，确属本人所有，不冒用、盗用他人信息；若您拒绝提供或提供的信息不符，将无法使用平台部分核心服务，但可正常使用基础浏览等非核心功能。
      <br> d.实名认证相关信息由您主动填写、上传，平台不自动收集；收集时将通过页面显著提示、弹窗等方式，再次明确告知信息使用用途及保护措施，确保您充分知情、自愿提交。
      <br>
      <br> （二）账号真人认证
      <br> a.为审核及验证您申请真人认证的账号真实性，确认真人认证与认证头像一致。
      <br> b.真人认证成功后，您的平台个人资料页将显示专属认证标识，提升账号可信度及社交认可度。
      <br> c.请谨慎选择是否申请真人认证，一旦申请并通过；若您拒绝提供或未通过真人认证，将无法使用平台相关特权功能，但不影响实名认证及基础服务的正常使用。
      <br>
      <br> （三）信息处理授权与限制
      <br> a.您同意授权平台及合作第三方认证机构，在本协议约定范围内收集和处理您的身份信息（姓名、身份证号）及人脸信息（视频、照片、面部特征），仅用于完成身份核验、提升认证的准确性和安全性，第三方认证机构不得超范围收集、使用、泄露相关信息。
      <br> b.您同意平台将您提供的实名认证信息、人脸信息，与法律法规允许或政府授权的权威机构数据进行比对核验，确保信息真实、合法、有效，核验过程将采取加密传输、安全隔离等措施，保障信息安全。
      <br> c.人脸信息、身份证号等敏感信息的收集、使用、存储、传输与保护，将严格遵守《隐私政策》及国家相关法律法规，采取加密存储、访问权限管控、安全审计等特殊保护措施，防范信息泄露、篡改、丢失风险。
      <br> d.所有认证相关信息仅用于本协议明确的认证及平台核心服务相关场景，不用于商业营销、用户画像等无关用途；未经您单独同意，平台不向任何无关第三方共享、转让、出租您的认证信息（法律法规另有规定的除外）。
      <br> e.敏感信息保存期限遵循“最少必要”原则：身份证号、人脸信息保存至您的账号存续期间及账号注销后6个月（用于处理注销后可能出现的纠纷、履行监管义务）；认证头像保存至您注销账号或主动申请删除后3个工作日，期满后将彻底删除或进行匿名化处理（匿名化后的数据无法识别您的身份）。
    </div>

    <h3> 三、 用户义务与须知</h3>
    <div>
      <br> 1. 信息真实性义务：您必须确保提交的所有认证相关信息（包括认证头像、人脸信息、姓名、身份证号等）真实、准确、合法，确属您本人所有，且仅用于您本人的平台账户服务，不得冒用、盗用他人信息，不得提交虚假、失效信息。
      <br> 2.
      禁止行为：严禁冒用/盗用他人身份信息、提供虚假认证信息、利用系统漏洞规避认证、泄露或转让自身认证信息、使用AI合成人脸/头像进行认证等违规行为；一经发现，平台有权据此拒绝或终止为您提供认证及相关服务，您需自行承担由此产生的法律及经济责任，平台有权向相关监管部门举报。
      <br> 3. 责任承担：因您提供的认证信息有误、不完整，或因您违规操作、泄露相关信息导致的账号异常、权益受损、平台损失，均由您自行承担，平台不承担任何赔偿责任。
      <br> 4. 违规处理：任何违反本协议及平台相关规则的行为，平台均有权根据违规情节轻重，采取拒绝提供认证服务、暂停账号功能、撤销认证资质、封禁账号等措施，无需事先通知。
      <br> 5.
      信息保护与沟通：我们高度重视您的个人信息安全，严格履行信息保护义务。若您对认证信息处理有疑问、建议，或需行使查询、更正、删除、撤回同意等法定权利，请通过《隐私政策》中载明的联系方式联系我们，我们将在3个工作日内响应、7个工作日内完成处理并反馈。
      <br> 6. 技术限制：认证成功率受技术水平及环境因素（如光线、表情、妆容、网络状况等）影响，我们无法保证每次认证均能成功，您可按系统提示调整后重新尝试。
      <br> 7. 认证失败处理：如认证失败，系统将提示具体失败原因，您可根据提示调整信息、环境后重新尝试；若多次认证失败，可通过平台“在线客服”联系我们协助处理。
      <br> 8. 风险控制：为保障您的账号安全及平台服务合规，平台有权在认为您的认证过程、账号存在安全风险（如身份信息疑似冒用、认证行为异常等）时，暂停认证服务或要求您补充校验信息，您需配合平台完成核查。
    </div>

    <h3> 四、其他条款</h3>
    <div>
      <br> 1.协议更新：为优化认证服务、适应国家法律法规、政策及技术发展变化，我们会适时修订本协议，并在平台显著位置（如首页弹窗、设置页面）依法公示，公示期限不少于7天。若您在协议修订后继续使用平台认证服务，即视为接受修订后的全部内容；如有异议，请及时联系我们，或停止使用相关服务。
      <br> 2.遵守规范：您在使用平台认证服务及相关功能时，须严格遵守国家相关法律法规及平台各项规则。平台有权依据本协议及平台规则，对您的违规行为进行处理，但不免除您应自行承担的法律责任。
      <br> 3.协议关联：本协议与平台《隐私政策》互为补充，若本协议约定与《隐私政策》不一致，以本协议为准；本协议未明确约定的，适用《隐私政策》相关规定。
      <br> 4.争议解决：本协议的解释及相关争议解决，均适用中华人民共和国大陆地区法律。任何因本协议以及我们处理您认证相关个人信息事宜引起的争议，您同意向平台运营方住所地有管辖权的法院提起诉讼，寻求解决方案。
      <br> 5.标题说明：本协议各条款标题仅为阅读便利而设置，不影响条款本身的含义或法律效力，也不用于解释条款内容。
      <br> 6.免责说明：因不可抗力（如地震、台风、网络中断、系统故障等不可预见、不可避免的情形）导致认证服务异常、无法正常提供的，平台不承担相关责任，但将尽力采取补救措施，及时恢复服务，并通知受影响的用户。
      <br> 7.条款效力：本协议部分条款若因违反相关法律法规而被认定为无效或可撤销，不影响其他条款的法律效力，其他条款仍对双方具有约束力。
    </div>

    <h3> 五、如何联系我们</h3>
    <div>
      <br> 您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
      <br> 1.如对本政策内容有任何疑问、意见或建议，您可在陌撩漂流瓶APP中通过陌撩漂流瓶小助手与我们联系，或者向我们的服务邮箱moliaos@163.com发送邮件；
      <br> 2.如发现个人信息可能被泄露，您可以发邮件至moliaos@163.com投诉举报；
      <br> 3.我们的注册地址与常用办公地址为江苏省徐州市睢宁县邱集镇工业集中区611号，个人信息保护相关负责人的联系方式为moliaos@163.com。
      <br> 如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，
      <b>您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</b>
    </div>

    <br>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style>

.privacy {
  width: 92%;
  max-width: 960px;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.privacy h3 {
  margin-top: 20px;
}


</style>
